/**
 * COMENTAR Y REACCIONAR SOBRE UNA TARJETA, VENGA DE DONDE VENGA.
 *
 * QUÉ PROBLEMA RESUELVE. Una tarjeta de Actividad puede ser un partido de
 * cuadro o un reto, y cada uno se comenta por SU ruta: son dos tablas, y con
 * la ruta equivocada el comentario cae en la otra o en ninguna. Esa decisión
 * —«de qué clase es esto»— se tomaba dentro de la pantalla de Actividad, y en
 * cuanto la misma tarjeta se dibuja en otro lado hay una segunda copia que
 * puede decidir distinto.
 *
 * ACÁ VIVE UNA SOLA VEZ, y las pantallas solo se ocupan de qué hacer con la
 * respuesta —volver a pedir la lista, o solo esta tarjeta—, que es lo único
 * que de verdad cambia entre una y otra.
 */
import type { ActivityEntry, MatchComment, PlayedMatchKind, WallReactionCount } from '@tennisup/contracts';

import { api } from './api';

/** Escribir debajo de esa tarjeta. */
export function comentarEn(entrada: ActivityEntry, body: string): Promise<MatchComment> {
  return entrada.kind === 'TOURNAMENT'
    ? api.addComment(entrada.id, body)
    : api.addChallengeComment(entrada.id, body);
}

/** Poner o quitar una reacción. Contesta la cuenta nueva. */
export function reaccionarEn(
  entrada: ActivityEntry,
  emoji: string,
  on: boolean,
): Promise<WallReactionCount[]> {
  return entrada.kind === 'TOURNAMENT'
    ? api.setReaction(entrada.id, emoji, on)
    : api.setChallengeReaction(entrada.id, emoji, on);
}

/**
 * LA DIRECCIÓN DE UN PARTIDO.
 *
 * `torneo` O `reto` EN LA DIRECCIÓN, y no el id solo: un id de partido y uno
 * de reto son de dos tablas distintas, y con una sola forma de dirección la
 * pantalla tendría que probar en una y después en la otra —y el día que un id
 * exista en las dos, abre la equivocada—. La dirección lo dice, y además se
 * lee: quien ve el enlace pegado en un chat sabe qué va a abrir.
 */
export function rutaDelPartido(kind: PlayedMatchKind, id: string): string {
  return `/partidos/${kind === 'TOURNAMENT' ? 'torneo' : 'reto'}/${id}`;
}
